import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance, axiosNewApiInstance } from "../../services/api.js";

// ! BALANCE

// Get Reports statistics +
export const getBalanceStatistics = createAsyncThunk(
  "reports/getBalanceStatistics",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/balance/statistics`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getBalanceStatistics", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get cars in work & ready list +
export const getWorkAndReadyList = createAsyncThunk(
  "reports/getWorkAndReadyList",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/balance/in_work/completed`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getWorkAndReadyList", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Suppliers Report +
export const getSuppliersBalanceReport = createAsyncThunk(
  "reports/getSuppliersBalanceReport",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/balance/suppliers`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getSuppliersBalanceReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Employees Balance Report +
export const getEmployeesBalanceReport = createAsyncThunk(
  "reports/getEmployeesBalanceReport",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/balance/employee`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getEmployeesBalanceReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get warehouses balance report +
export const getWarehousesBalanceReport = createAsyncThunk(
  "reports/getWarehousesBalanceReport",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/balance/warehouse`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getWarehousesBalanceReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get CashRegisters Report +
export const getCashRegistersReport = createAsyncThunk(
  "reports/getCashRegistersReport",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/balance/cashregisters`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getCashRegistersReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Balance Sales Report +
export const getBalanceSalesReport = createAsyncThunk(
  "reports/getBalanceSalesReport",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/balance/sales`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getBalanceSalesReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! SUPPLIERS REPORTS

// Get Suppliers statistics
export const getSuppliersStatistics = createAsyncThunk(
  "reports/getSuppliersStatistics",
  async (period, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const { start_date, end_date } = period;
      const response = await axiosInstance.get(`/report_sup/suppliers_stat`, {
        params: {
          start_date,
          end_date,
        },
        headers: {
          "company-id": serviceId,
        },
      });
      console.log("getSuppliersStatistics", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get NotSold Report
export const getNotSoldReport = createAsyncThunk(
  "reports/getNotSoldReport",
  async (period, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const { start_date, end_date } = period;
      const response = await axiosInstance.get(`/report_sup/not_sold_report`, {
        params: {
          start_date,
          end_date,
        },
        headers: {
          "company-id": serviceId,
        },
      });
      console.log("getNotSoldReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Suppliers report
export const getSuppliersReport = createAsyncThunk(
  "reports/getSuppliersReport",
  async (period, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const { start_date, end_date } = period;
      const response = await axiosInstance.get(
        `/report_sup/supplier_car_table`,
        {
          params: {
            start_date,
            end_date,
          },
          headers: {
            "company-id": serviceId,
          },
        }
      );
      console.log("getSuppliersReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! CLIENTS REPORTS
// Get Clients Report
export const getClientsReport = createAsyncThunk(
  "reports/getClientsReport",
  async (period, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const { start_date, end_date } = period;
      const response = await axiosInstance.get(`/rep/get_clients_report`, {
        params: {
          start_date,
          end_date,
        },
        headers: {
          "company-id": serviceId,
        },
      });
      console.log("getClientsReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! PROFIT REPORTS
// Get Profit statistics
export const getProfitStatistics = createAsyncThunk(
  "reports/getProfitStatistics",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/profit/statistics`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getProfitStatistics", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Profit Parts Report +
export const getProfitPartsReport = createAsyncThunk(
  "reports/getProfitPartsReport",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/parts/payments`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getProfitPartsReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Profit Works Report +
export const getProfitWorksReport = createAsyncThunk(
  "reports/getProfitWorksReport",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/parts/work-profit`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getProfitWorksReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Profit Others Income Report +
export const getProfitOthersIncomeReport = createAsyncThunk(
  "reports/getProfitOthersIncomeReport",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/other/payments`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getProfitOthersIncomeReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Mechanic Salary Report +
export const getMechanicSalaryReport = createAsyncThunk(
  "reports/getMechanicSalaryReport",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/mechanic/payments`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getMechanicSalaryReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Staff Salary Report +
export const getStaffSalaryReport = createAsyncThunk(
  "reports/getStaffSalaryReport",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/employee/payments`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getStaffSalaryReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Taxes Report +
export const getTaxesReport = createAsyncThunk(
  "reports/getTaxesReport",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/vat/payments`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getTaxesReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Expanses Report +
export const getExpansesReport = createAsyncThunk(
  "reports/getExpansesReport",
  async (period, thunkAPI) => {
    try {
      const { from_date, to_date } = period;
      const response = await axiosNewApiInstance.get(
        `/api/v1/reports/expenses/payments`,
        {
          params: {
            from_date,
            to_date,
          },
        }
      );
      console.log("getExpansesReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// ! WAREHOUSES REPORTS

// Get Warehouses statistics
export const getWarehousesStatistics = createAsyncThunk(
  "reports/getWarehousesStatistics",
  async (period, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const { start_date, end_date } = period;
      const response = await axiosInstance.get(`/rep/warehouse/statistics`, {
        params: {
          start_date,
          end_date,
        },
        headers: {
          "company-id": serviceId,
        },
      });
      console.log("getWarehousesStatistics", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Warehouses Report and Initial stock stat
export const getWarehousesReport = createAsyncThunk(
  "reports/getWarehousesReport",
  async (period, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const { start_date, end_date } = period;
      const response = await axiosInstance.get(`/rep/warehouse/parts-check`, {
        params: {
          start_date,
          end_date,
        },
        headers: {
          "company-id": serviceId,
        },
      });
      console.log("getWarehousesReport", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Warehouses Returns
export const getWarehousesReturns = createAsyncThunk(
  "reports/getWarehousesReturns",
  async (period, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const { start_date, end_date } = period;
      const response = await axiosInstance.get(`/rep/warehouse/returns`, {
        params: {
          start_date,
          end_date,
        },
        headers: {
          "company-id": serviceId,
        },
      });
      console.log("getWarehousesReturns", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);

// Get Warehouses Disposals
export const getWarehousesDisposals = createAsyncThunk(
  "reports/getWarehousesDisposals",
  async (period, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const { start_date, end_date } = period;
      const response = await axiosInstance.get(`/rep/warehouse/disposal`, {
        params: {
          start_date,
          end_date,
        },
        headers: {
          "company-id": serviceId,
        },
      });
      console.log("getWarehousesDisposals", response.data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return thunkAPI.rejectWithValue({ status: 404, message: "Not found" });
      }
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
